<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :status="status" :ok-text="okText" @show="showModal" @hidden="resetModal"
                 :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">

    <b-card-title>{{ name }}</b-card-title>

    <t-input v-if="enableAccessCode" v-model="form.newPassword" only-numbers min-length="6" max-length="6" :add-error="error.newPassword" label="Novo PIN" required/>

    <t-input v-else v-model="form.newPassword" password-security :add-error="error.newPassword" label="Nova senha" required/>


  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";

export default {
  name: "UserChangePasswordDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-user-change-password",
      title: "Alteração de Senha",
      okText: "Trocar Senha",
      form: {
        userId: 0,
        newPassword: "",
      },
      error: {//Campos que podem receber retorno de erro do backend
        newPassword: "",
      },
    }
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    enableAccessCode: {
      type: Boolean,
      required: true,
    },
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    showModal() {

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora

    },

    async onSubmit() {

      //Validações específicas da tela
      this.form.userId = this.userId

      await this.putDialog("admin/user/changePassword", () => {
        this.successInsert()
      })

    }
  },
  watch: {
    noOptionAdd() {
      this.form.name = this.noOptionAdd
    }
  }
}
</script>
